<template>
  <Modal :title="title" :showModal="showModal" class="history-form">
    <template v-slot:body>
      <div class="vertical-timeline vertical-timeline--animate vertical-timeline--one-column">
        <div v-for="(item, index) in data" :key="index" class="vertical-timeline-item vertical-timeline-element">
          <span class="vertical-timeline-element-icon bounce-in">
            <i class="badge badge-dot badge-dot-xl badge-success">&nbsp;</i>
          </span>
          <div class="vertical-timeline-element-content bounce-in">
            <h4 class="timeline-title">{{ item.action }}</h4>
            <p class="timeline-user"><i class="lnr-user"></i>{{ item.user }}</p>
            <div class="description">
              <div v-if="item.description.action" class="action">
                <label>Action:&nbsp;</label>
                <span>{{ item.description.action }}</span>
              </div>
              <div v-if="item.description.delivery_info" class="buyer-info">
                <strong v-if="item.description.delivery_info.name" class="select-all">{{ item.description.delivery_info.name }}</strong>
                <span v-if="item.description.delivery_info.line" class="first-line select-all" v-html="Object.values(item.description.delivery_info.line).join('\n')"></span>
                <span v-if="item.description.delivery_info.city" class="city select-all">{{ item.description.delivery_info.city }}</span>
                <span v-if="item.description.delivery_info.state" class="state select-all">{{ item.description.delivery_info.state }}</span>
                <span v-if="item.description.delivery_info.zip" class="zip select-all">{{ item.description.delivery_info.zip }}</span>
                <span v-if="item.description.delivery_info.note" class="order-note select-all">{{ item.description.delivery_info.note }}</span>
              </div>
              <div v-if="item.description.note" class="order-note mt-2">
                <span class="order-note select-all">{{ item.description.note }}</span>
              </div>
              <div v-if="item.description.status" class="order-status mt-2">
                <div v-if="item.description.status" class="design-status">
                  <label>Status:&nbsp;</label><span>{{ item.description.status_label }}</span>
                </div>
              </div>
              <div v-if="item.description.purchase_detail" class="order-purchase-detail mt-2">
                <div v-if="item.description.purchase_detail.prices" class="prices">
                  <label>
                    <span>Purchase Price:&nbsp;</span>
                    <p v-for="(price, priceIndex) in item.description.purchase_detail.prices" :key="priceIndex" class="price">{{ price.price }}{{ price.currency }}</p>
                  </label>
                </div>
                <div v-if="item.description.purchase_detail.shipments">
                  <label>Shipments:</label>
                  <p v-for="(shipment, shipmentIndex) in item.description.purchase_detail.shipments" :key="shipmentIndex" class="shipment">{{ shipment.carrier }}:&nbsp;{{ shipment.number }}</p>
                </div>
              </div>
            </div>
            <span v-if="item.time" class="vertical-timeline-element-date" v-html="$util.timestampToDateTime(item.time, true)"></span>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  data() {
    return {
      data: []
    }
  },
  computed: {
    title() {
      return 'History'
    },
    action() {
      return 'history'
    },
    storeId() {
      return this.config?.storeId
    },
    orderId() {
      return this.config?.data?._id
    },
    getUri() {
      return `order/history/${this.orderId}`
    }
  },
  methods: {
    setUpData(rawData) {
      if (rawData.status == 'success') {
        this.showModal = true
        this.data = rawData.data
      }
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
.modal.history-form {
  .vertical-timeline {
    overflow: hidden;
  }
}
</style>
